import { ROWS_PER_PAGE } from "app/pages/industry-analysis/market-builder/tabs/common/utils";
import styled from "styled-components";
import { TableLoader as TableLoaderView } from "app/components/React/Table/FlexTable/Big/FlexTableStatelessComponents";

const Container = styled.div`
    height: 100px;
    overflow-y: auto;
    display: flex;
    flex: 1 1 auto;
    width: 100%;
`;
const LoaderContainer = styled.div`
    width: 100%;
`;

export const TableLoader = () => {
    return (
        <Container>
            <TableLoaderView
                rowNum={ROWS_PER_PAGE}
                Container={LoaderContainer}
            />
        </Container>
    );
};
